
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import LoginForm from "./LoginForm";
import SignupForm from "./SignupForm";
import { useEffect } from "react";

interface AuthTabsProps {
  email: string;
  setEmail: (email: string) => void;
  password: string;
  setPassword: (password: string) => void;
  isLoading: boolean;
  handleSubmit: (e: React.FormEvent, mode: "login" | "signup") => void;
  handleSocialLogin: (provider: 'google') => Promise<void>;
  defaultTab?: string;
}

const AuthTabs = ({
  email,
  setEmail,
  password,
  setPassword,
  isLoading,
  handleSubmit,
  handleSocialLogin,
  defaultTab = 'login'
}: AuthTabsProps) => {
  const handleTabChange = (value: string) => {
    console.log('Auth Tabs - Tab Changed', {
      selectedTab: value
    });
  };

  // Log component mounting to track render cycle
  useEffect(() => {
    console.log('Auth Tabs - Component Mounted', {
      currentEmail: email,
      isLoading,
      defaultTab
    });
    
    return () => {
      console.log('Auth Tabs - Component Unmounted');
    };
  }, [email, isLoading, defaultTab]);

  return (
    <Tabs 
      defaultValue={defaultTab} 
      className="w-full" 
      onValueChange={handleTabChange}
    >
      <TabsList className="w-full grid grid-cols-2 rounded-none">
        <TabsTrigger value="login">Log In</TabsTrigger>
        <TabsTrigger value="signup">Sign Up</TabsTrigger>
      </TabsList>
      
      <TabsContent value="login" className="p-6">
        <LoginForm
          email={email}
          setEmail={setEmail}
          password={password}
          setPassword={setPassword}
          isLoading={isLoading}
          handleSubmit={(e) => {
            console.log('Login Form - Submit Clicked', { email });
            handleSubmit(e, "login");
          }}
          handleSocialLogin={handleSocialLogin}
        />
      </TabsContent>
      
      <TabsContent value="signup" className="p-6">
        <SignupForm
          email={email}
          setEmail={setEmail}
          password={password}
          setPassword={setPassword}
          isLoading={isLoading}
          handleSubmit={(e) => {
            console.log('Signup Form - Submit Clicked', { email });
            handleSubmit(e, "signup");
          }}
          handleSocialLogin={handleSocialLogin}
        />
      </TabsContent>
    </Tabs>
  );
};

export default AuthTabs;
